<div class="warp-data-summary">
  <img class="imgType" src="/assets/images/types/{{ questionData?.question?.type?.image }}" />
  <div class="flex-warp">
    <div class="warp-data-question" [ngClass]="{'in-row-filter':filterRecipients$()!=undefined}">
      <div class="data-question">
        {{ questionData?.question | questionTitle }}
      </div>
      <div class="comments" *ngIf="filterRecipients$()==undefined">
        <p>{{ questionData?.comments }}</p>
        <p translate>data.comments</p>
      </div>
      <div *ngIf="showComparison$()" class="warp-tag-compare">
        <div>
          <p class="tag" translate>data.current</p>
        </div>
        <div>
          <p class="tag" translate>data.previous</p>
        </div>
      </div>
      <div *ngFor="let ans of recipients; let i = index" [ngClass]="{ warp: showComparison$() }">
        <div class="row-data">
          <que-row-data [filterRecipients]="filterRecipients$()" [answerByRecipient]="ans"
            [question]="questionData?.question" *ngIf="showAll || i < 5"></que-row-data>
        </div>
        <div class="row-data" *ngIf="showComparison$()">
          <que-row-data [filterRecipients]="filterRecipients$()" [answerByRecipient]="ans"
            [question]="questionData?.question" *ngIf="showAll || i < 5" [isSource]="true"></que-row-data>
        </div>
      </div>
    </div>
    <div class="warp-button-data" *ngIf="(recipients?.length ?? 0) > 5">
      <div *ngIf="!showAll" (click)="showHide()" class="show-button pointer" translate>
        data.summary.showAll
      </div>
      <div *ngIf="showAll" (click)="showHide()" class="hide-button pointer" translate>
        data.summary.hide
      </div>
    </div>
  </div>
</div>

<!-- "data": {
    "summary": {
        "title": "Summary",
        "comments": "Comments",
        "showAll": "Show All",
        "showMore": "Show More",
        "hide": "Hide"
    }, -->